import { render, staticRenderFns } from "./wy-configuration-usage-tab.vue?vue&type=template&id=5e0d7d21&"
import script from "./wy-configuration-usage-tab.vue?vue&type=script&lang=js&"
export * from "./wy-configuration-usage-tab.vue?vue&type=script&lang=js&"
import style0 from "./wy-configuration-usage-tab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports